import React, {useState} from 'react'
import CSRF from 'js/components/CSRF'

import {
  AlignItems,
  AppWrapper,
  ButtonType,
  CTAButton,
  ComponentColor,
  ComponentSize,
  ComponentStatus,
  FlexBox,
  FlexDirection,
  FontWeight,
  FunnelPage,
  Heading,
  HeadingElement,
  InfluxColors,
  JustifyContent,
  Panel,
} from '@influxdata/clockface'

import LogoWithCubo from 'js/components/LogoWithCubo'

interface Props {
  currentEmail: string
  inviteEmail: string
  token: string
}

const InviteEmailError = ({
  currentEmail,
  inviteEmail,
  token,
}: Props): JSX.Element => {
  const [buttonStatus, updateStatus] = useState<ComponentStatus>(
    ComponentStatus.Default
  )

  const handleSubmit = () => {
    updateStatus(ComponentStatus.Loading)
  }

  return (
    <AppWrapper type="funnel">
      <FunnelPage enableGraphic={true} logo={<LogoWithCubo />}>
        <FlexBox
          alignItems={AlignItems.Center}
          justifyContent={JustifyContent.Center}
          direction={FlexDirection.Column}
          style={{marginTop: '14vh'}}
        >
          <Heading
            element={HeadingElement.H1}
            weight={FontWeight.Black}
            className="cf-funnel-page--title"
            style={{marginBottom: '1.5em'}}
          >
            This invite is for a different email
          </Heading>
          <form
            data-testid="invite-logout-form"
            action={`/invites/reset/${token}`}
            method="GET"
            onSubmit={handleSubmit}
          >
            <CSRF />
            <Panel
              backgroundColor={InfluxColors.Grey15}
              style={{maxWidth: '60vw', padding: '2em 3em'}}
            >
              <Panel.Body style={{margin: 'lg'}}>
                <FlexBox
                  alignItems={AlignItems.Center}
                  direction={FlexDirection.Column}
                  justifyContent={JustifyContent.Center}
                  margin={ComponentSize.Medium}
                >
                  <Heading element={HeadingElement.P} weight={FontWeight.Light}>
                    We noticed you are currently logged in with with the
                    following email address:
                  </Heading>
                  <Heading
                    element={HeadingElement.P}
                    style={{color: InfluxColors.Pool}}
                  >
                    {currentEmail}
                  </Heading>
                  <Heading element={HeadingElement.P} weight={FontWeight.Light}>
                    This does not match the email address on the
                    invitation:{' '}
                  </Heading>
                  <Heading
                    element={HeadingElement.P}
                    style={{color: InfluxColors.Pool, marginBottom: '3.5em'}}
                  >
                    {inviteEmail}
                  </Heading>
                  <Heading element={HeadingElement.P} weight={FontWeight.Light}>
                    To accept this invitation, please <b>log out</b> and{' '}
                    <b>sign in</b> with the matching email address.
                  </Heading>
                </FlexBox>
              </Panel.Body>
            </Panel>
            <FlexBox
              alignItems={AlignItems.Center}
              direction={FlexDirection.Column}
              justifyContent={JustifyContent.Center}
              style={{marginTop: '3em'}}
            >
              <CTAButton
                className="email-error--cta-button"
                color={ComponentColor.Primary}
                status={buttonStatus}
                text="Logout"
                type={ButtonType.Submit}
              />
            </FlexBox>
          </form>
        </FlexBox>
      </FunnelPage>
    </AppWrapper>
  )
}

export default InviteEmailError
